import React, {useEffect } from 'react'; 
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const Withdrawal = () => {
    useEffect(() => {
        document.title = 'Withdrawal -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> The Almanac  </li>
                 <li>School Rules</li>
                 <li>Withdrawal</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Withdrawal </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12"> 
                    <ul className="list"> 
                    <li>TC Application form must be signed by both parents. </li>
                    <li>One month's notice must be given in writing for a withdrawal. In case of a short notice period, fee for the next month will be charged. </li>
                    <li>A student will be issued a Transfer Certificate only when the school dues have been cleared. </li>
                    <li>I-Card & Library Card must be returned to the librarian before clearance. </li>
                    <li>The first and last payment of school dues must be done only in cash. </li>
                    <li>In case a student is leaving Delhi, the Transfer Certificate must be counter signed by The Education Officer, Zone XX, C-4 Vasant Vihar, New Delhi. </li>
                    
                    </ul> 
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Withdrawal